export const BENCHMARK_COPY = {
  muchHigher: 'Much more favorable than benchmark',
  higher: 'More favorable than benchmark',
  similar: 'Similar to benchmark',
  lower: 'Less favorable than benchmark',
  muchLower: 'Much less favorable than benchmark',
  notYetAvailable: 'Benchmark not yet available',
};
